import React from 'react'
import styled from "styled-components"

export const Heading = styled.h3`
  &&& {
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
    text-align: left;
    letter-spacing: 0.4px;
    margin-top: 0;
    /* margin-bottom: ${props => (props.noMarginBottom ? 0 : "1rem")}; */
    color: #2B3647;
  }
`

export const HeadingLink = Heading.withComponent("li")

export const Text = styled.p`
  &&& {
    font-size: 16px;
    line-height: 1.25;
    color: rgba(41, 55, 74, 0.6);
    text-align: left;
    margin: 2px 0 0;
  }
`;

export const Label = styled.span`
  font-size:12px;
  color: rgba(41, 55, 74, 0.6);
  text-transform:uppercase;
  letter-spacing:1px;
  margin-bottom: 4px;
`;

export const LinkList = styled.ul`
  li {
    margin-bottom: 1rem;
  }

  li:last-of-type {
    margin-bottom: 0;
  }
  
  margin-left: ${props => (props.marginLeft ? props.marginLeft : 0)};
`

export const DropdownSection = styled.div`
  padding: 36px 28px; /* --spacer */
  position: relative;
  z-index: 1;
`

export const DropdownList = styled.ul`
  padding: 0;
  margin: -8px 0;
  font-size: 16px;
  font-family: 'DIN', sans-serif;

  li {
    display: flex;
    margin-bottom: 1rem;
  }

  li:last-of-type {
    margin-bottom: 0;
  }

  h3 {
    margin-right: 1rem;
    width: 3.2rem;
    display: block;
  }
  a {
    color: #6b7c93;
  }

  a:hover {
    opacity: 0.7;
    text-decoration: none;
  }
`

const Logo = styled.div`
  display: flex;
  padding-right: 18px;
`

const Link = styled.a`
  display: flex;
  align-items: center;
  margin-bottom: ${props => (props.marginBottom ? `${props.marginBottom}px` : '24px')};
  text-decoration: none;

  &:last-of-type {
    margin-bottom: 0;
  }

  &:hover {
    text-decoration: none;
    opacity: 0.7;
  }

  &:visited, &:active, &:focus {
    text-decoration: none;
  }
`;

export const DropdownItem = props => <Link marginBottom={props.marginBottom || 36} href={props.href}>
  <Logo>
    {props.logo}
  </Logo>
  <div>
    <Heading color={props.color}>{props.title}</Heading>
    <Text>{props.description}</Text>
  </div>
</Link>